import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class labelsDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  private labelsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $labels, private $log) {
  }



  $onInit() {
    this.labelsRef = this.$labels();
    this.setItems(this.ids);
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    this.displayItems = (ids && ids.length) ? ids : [];
  }



}

angular
  .module('bringoz.admin.labels')
  .component('labelsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./labels-display-list.html').default,
    controller: labelsDisplayListCtrl
  });
